import { Box, Grid, Typography, Tooltip, IconButton } from '@mui/material';
import { FieldWithInlineEdit, IComponentCss, LinearProgressChart } from '@tap/mui-ui';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { useTimeTracking } from './TimeTrackingContext';
import { useDocument } from '../../context';
import { dateTimeHelper } from '@tap/utils';

export type TimeTrackingWidgetValue = {
    estimateMin: number,
    leftMin: number,
    spentMin: number,
}

type TimeTrackingWidgetProps = {
    hideAddTimeBtn?: boolean,
}


type PureTimeTrackingWidgetProps = {
    value: TimeTrackingWidgetValue,
    hideAddTimeBtn?: boolean,
    openAddTimeTrackingDialog: () => void,
}

const css: IComponentCss = {
    widgetBox: {
        width: '100%',
        position: 'relative',
    },
    addButton: {
        position: 'absolute',
        right: 0,
        top: '-34px',
    },
}

export const TimeTrackingWidget = ({
    hideAddTimeBtn = false,
}: TimeTrackingWidgetProps) => {
    const { openAddTimeTrackingDialog } = useTimeTracking();
    const { document } = useDocument();

    const value = {
        estimateMin: document?.data.timeTracking?.estimateMin || 0,
        leftMin: document?.data.timeTracking?.leftMin || 0,
        spentMin: document?.data.timeTracking?.spentMin || 0,
    };

    return (
        <PureTimeTrackingWidget
            value={value}
            openAddTimeTrackingDialog={openAddTimeTrackingDialog}
            hideAddTimeBtn={hideAddTimeBtn}
        />
    );
}


export const PureTimeTrackingWidget = ({ value, hideAddTimeBtn, openAddTimeTrackingDialog }: PureTimeTrackingWidgetProps) => {

    const scale = Math.max(value.estimateMin, value.spentMin + value.leftMin);

    const estimatePercent = scale ? value.estimateMin * 100 / scale : 0;
    const leftPercent = scale ? value.leftMin * 100 / scale : 0;
    const spentPercent = scale ? value.spentMin * 100 / scale : 0;

    return (
        <Box sx={css.widgetBox}>
            {!hideAddTimeBtn && (
                <Tooltip title='Отметить время'>
                    <IconButton
                        size='small'
                        sx={css.addButton}
                        onClick={openAddTimeTrackingDialog}
                    >
                        <AddOutlinedIcon />
                    </IconButton>
                </Tooltip>
            )}

            <Grid container>
                <FieldWithInlineEdit
                    md={12}
                    title={'Оценка'}
                    direction='vertically'
                >
                    <Grid container alignItems='center'>
                        <LinearProgressChart
                            value={estimatePercent}
                            chartStyle={{ width: '50%' }}
                        />
                        <Typography component='span' pl={1}>
                            {dateTimeHelper.timeFormat(value.estimateMin * 1000 * 60)}
                        </Typography>
                    </Grid>
                </FieldWithInlineEdit>

                <FieldWithInlineEdit
                    md={12}
                    title={'Осталось'}
                    direction='vertically'
                >
                    <Grid container alignItems='center'>
                        <LinearProgressChart
                            value={leftPercent}
                            chartStyle={{
                                width: '50%',
                                transform: 'rotate(180deg)',
                            }}
                            colorBar='#ff9100'
                        />
                        <Typography component='span' pl={1}>
                            {dateTimeHelper.timeFormat(value.leftMin * 1000 * 60)}
                        </Typography>
                    </Grid>
                </FieldWithInlineEdit>

                <FieldWithInlineEdit
                    md={12}
                    title={'Затрачено'}
                    direction='vertically'
                >
                    <Grid container alignItems='center'>
                        <LinearProgressChart
                            value={spentPercent}
                            chartStyle={{ width: '50%' }}
                            colorBar='#4caf50'
                        />
                        <Typography component='span' pl={1}>
                            {dateTimeHelper.timeFormat(value.spentMin * 1000 * 60)}
                        </Typography>
                    </Grid>
                </FieldWithInlineEdit>
            </Grid>

        </Box>
    );
}